import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild } from '@angular/core';
import { typesApex } from '../models';
import ApexCharts from 'apexcharts';
import { IMG } from '../../services/imagen/png';
import { TranslateService } from '@ngx-translate/core';
import { Aligment, ExcelService, FormatText } from '../../services/excel/excel.service';
import { formatear } from '../../elements/funciones/funcionesGenerales';
import { max } from 'moment';
import { toPng } from 'html-to-image';
import { GraficadorComponent } from '../graficador/graficador.component';

@Component({
  selector: 'app-graficas',
  templateUrl: './graficas.component.html',
  styleUrl: './graficas.component.css'
})
export class GraficasComponent implements OnChanges{
  public types = typesApex;
  public typeGrphic = typesApex.COMBO;
  public etiquetas = true;
  public showLabel = 0;
  public perspectiveSelected = '';

  public chart;
  private options;

  public dataTable = [];

  public chartAmp;

  
  private marginL = 25;
  private marginR = 25;
  private ancho = 480;

  @Input() data: any[];
  @Input() labels: string[];
  @Input() type: string;
  @Input() colors = ['#004A97', '#68B4D6', '#82CC60', '#FFCB03', '#FC8A33', '#F74C58'];
  @Input() axisY: string[];
  @Input() tituloZona: string;
  @Input() subTituloZona: string;
  @Input() zona: number;
  @Input() graphicsAvaibable: string[];
  @Input() perspectivesAvaibable = [];
  @Input() animations: boolean = true;
  @Input() exportSuc: boolean = false;

  @Output() eventClick = new EventEmitter;
  @Output() perspectiveClick = new EventEmitter;
  @Output() exportSucursales = new EventEmitter;

  constructor(
    private translate: TranslateService,
    private excel: ExcelService,
  ){}
  ngOnChanges(changes: SimpleChanges): void {
    if(changes['data'] && this.type !== this.types.TABLE && this.data.length !== 0){
      this.optionsGraphic();
    }else if(changes['data'] && this.data.length !== 0){
      this.optionsTable();
    }
  }
  /* Cambio de gráficas */
  public changeGraphic(type: string){
    this.type = type;
    if(type && type !== this.types.TABLE){
      this.data.forEach( (d, index) =>{
        if(type === this.types.COMBO){
          d.type = index===0?this.types.LINE:this.types.BAR;
        }else{
          d.type = type===typesApex.STACKED || type===typesApex.FUNNEL? undefined: type;
        }
      });
      this.optionsGraphic();
    }else{
      this.optionsTable();
    }
  }
  /* CReación de la tabla y de la gráfica */
  private optionsGraphic(){
  }
  /* formateo de gráficas */
  private formatData(){
    var dataFormat;
    switch(this.type){
      case typesApex.HEATMAP:
        dataFormat = this.data.map( d => {
          return {
            data: d.data.map( (elem, index) => {
              return {
                x: this.labels[index],
                y: elem
              }
            })
          }
        });
      break;
      case typesApex.DONUT:
      case typesApex.PIE:
        dataFormat = this.data[0].data;
      break;
      case typesApex.COMBO:
        dataFormat = this.data.map( (d, i) => {
          return {...d, type: i===this.data.length-1?'line':'bar'}
        });
      break;
      default:
        dataFormat = JSON.parse(JSON.stringify(this.data));
      break;
    }
    return dataFormat;
  }
  private caracteristicas(){
    var typeGraph = '', stacked = false, funnel = false;
    switch(this.type){
      case typesApex.COMBO:
        typeGraph = typesApex.BAR;
      break;
      case typesApex.STACKED:
        typeGraph = typesApex.BAR;
        stacked = true;
      break;
      case typesApex.FUNNEL:
        typeGraph = typesApex.BAR;
        funnel = true;
      break;
      default:
        typeGraph = this.type;
      break;
    }

    return {typeGraph, stacked, funnel}
  }
  private plotOptions(funnel){
    switch(this.type){
      case typesApex.DONUT:
        this.options['plotOptions'] = {
          pie: {
            donut: {
              size: '50%'
            }
          }
        }
      break;
      case typesApex.BAR:
      case typesApex.COMBO:
      case typesApex.FUNNEL:
        this.options['plotOptions'] = {
          bar: {
            isFunnel : funnel,
            barHeight: funnel?"80%":undefined,
            horizontal: funnel?true:undefined,
            dataLabels: {
              position: funnel?"center":"top" // top, center, bottom
            }
          }
        }
      break;
    }
  }
  private setEjes(dataFormat){
    if(this.data.length > 1 && this.type !== typesApex.STACKED){
      this.changeLabels()
      var axisY = [];
      var stroke = [];
      this.axisY.forEach( (eje, i) =>{
        var max = Math.max(... dataFormat[i].data) * 1.05;
        var min = Math.min(... dataFormat[i].data) * 0.95;
        if(this.axisY.length !== dataFormat.length){
          const max_s = dataFormat.map( d => Math.max(...d.data) );
          const min_s = dataFormat.map( d => Math.min(...d.data) );
          max = Math.max(...max_s) *1.05;
          min = Math.min(...min_s) *0.95;
        }
        axisY.push({
          max: max,
          min: min,
          opposite: axisY.length<1?false:true,
          axisTicks: {
            show: true
          },
          axisBorder: {
            show: true,
          },
          title: {
            text: eje,
          },
          tooltip: {
            enabled: false
          },
          labels: {
            formatter: (val) => {
              return formatear.retornarformatolefty(val);
            },
            style: {
              fontSize: '12px',
              fontWeight: 600,
            },
          }
        });
        stroke.push(3);
      });
      this.options['stroke']['width'] = axisY.length === 1 ? stroke[0]:stroke;
      this.options['yaxis'] = axisY.length === 1 ? axisY[0]:axisY;
    }
  }
  /* */
  private optionsTable(){
    const auxData = JSON.parse(JSON.stringify(this.data));
    var auxTabla = []
    auxData.forEach( (d, i) =>{
      const total = Number(d.data.reduce((sum, value) => sum + value, 0).toFixed(1));
      // Calcular los porcentajes (evitando división por cero)
      const porcentaje = total === 0 
        ? d.data.map(() => 0) // Si total es 0, todos los porcentajes son 0%
        : d.data.map(value => parseFloat(((value / total) * 100).toFixed(2)));

      porcentaje.push(100);
      d.data.push(total);
      auxTabla.push({
        valores: d.data,
        name: d.name,
        porcentaje,
      });
    });
    this.dataTable = auxTabla;
  }
  /* Activaciones */
  public onOffLables(){
    this.etiquetas = !this.etiquetas;
  }
  public changeLabels(add?: string){
    // if(add){
    //   this.showLabel+1<this.data.length?this.showLabel++:this.showLabel=0;
    // }
    // if(this.etiquetas){
    //   if( this.type === typesApex.COMBO){
    //     this.options.dataLabels.enabledOnSeries = [this.showLabel];
    //   }
    //   if(this.options.series[this.showLabel].type === typesApex.BAR){
    //     this.options.dataLabels.offsetY = -20;
    //   }else{
    //     this.options.dataLabels.offsetY = -7;
    //   }
    // }
    // if(add){
    //   this.chart.destroy();
    //   if( document.getElementById("ampliar"+this.zona)!.style.display === 'block' ){
    //     this.chartAmp.destroy();
    //   }
    //   setTimeout(() =>{  
    //     this.chart = new ApexCharts(
    //       document.querySelector(`#grafica${this.zona}`),//id del div 
    //       this.options
    //     );
    //     this.chart.render();
    //     if( document.getElementById("ampliar"+this.zona)!.style.display === 'block' ){
    //       this.chartAmp = new ApexCharts(
    //         document.querySelector(`#graficaModal${this.zona}`),
    //         this.options
    //       );
    //       this.chartAmp.render();
    //     }
    //   }, 100);
    // }
  }
  /* Eventos click */
  public clickSeries(event){
    this.eventClick.emit(event);
  }
  public clickPerspective(event){
    this.perspectiveClick.emit(event);
  }
  /* Modales */
  modal = false;
  graficaAmpliar = false;
  @ViewChild('graficadorModal') graficadorModal: GraficadorComponent;
  public openModal(){
    this.modal = true;
    this.graficaAmpliar = true;
    // Letra más grande en la vista ampliada, con lo que ya trae el graficador
    setTimeout(() => this.graficadorModal?.changeFontSize(), 200);
  }
  public closeModal(){
    this.modal = false;
    this.graficaAmpliar = false;
  }
  public clickFuera(event){
    if (event.target === document.getElementById("ampliar"+this.zona)) {
      this.closeModal();
    }
  }
  /* Exportación */
  @ViewChild('graficador1') graficador1: GraficadorComponent;
  public export(){
    if(this.type !== this.types.TABLE){

      const titulos = {
        titulo: '',
        subtitulo: '',
        nombreArch: this.translate.instant(this.tituloZona)
      };
      if (this.graficador1) {
        this.graficador1.exportImg(1, titulos);
      }
    }else{
      var headers = ['', ...this.data.map( dat => dat.name)]
      var data = this.labels.map( (et, index) => [et, ...this.data.map( dat => dat.data[index])]);

      const tipos = data[0].map(elem => { 
        if (elem === null) return 'null';
        if (typeof elem === 'number') {
            return Number.isInteger(elem) ? 'integer' : 'float';
          }
          return typeof elem;
        });
      
      var formato = [];
      var aligment = [];

      for(const t of tipos){
        switch(t){
          case 'string':
            formato.push(FormatText.TEXT);
            aligment.push(Aligment.LEFT);
            break;
          case 'integer':
            formato.push(FormatText.NUMBER);
            aligment.push(Aligment.RIGHT);
            break;
          case 'float':
            formato.push(FormatText.NUMBERDEC);
            aligment.push(Aligment.RIGHT);
            break;
        }
      }
      this.excel.generateExcel(
        this.translate.instant(this.tituloZona),
        headers,
        data,
        this.translate.instant(this.tituloZona),
        aligment,
        formato
      );
    }
  }
  public exportImgBlob() {
    return new Promise(async (resolve) => {
      this.options.chart.animations.speed = 10;
      this.options.dataLabels.style.fontSize = '20px';
      this.options.xaxis.labels.style.fontSize = '22px';
      this.options.legend.fontSize = '21px';
      for(const y of this.options.yaxis){
        y.labels.style.fontSize = '22px';
        y.title.style.fontSize = '24px';
      }
      this.chartAmp = new ApexCharts(
        document.querySelector(`#graficaExport${this.zona}`),
        this.options
      );
      this.chartAmp.render();

      setTimeout(async () => {
        const canvas = await toPng(document.getElementById(`exportar${this.zona}`), {
          skipFonts: true,
          skipAutoScale: true,
          filter: (node) => !node.classList?.contains('dropdown-toggle')
        });
        const table = {
          widths: ['*'],
          body: [
            [
              {
                image: canvas,
                width: this.ancho,
              }
            ]
          ]
        }
        resolve(
        {
          alignment: 'center',
          table: table,
          width: '100%',
          margin: [0,15,0,15],
          layout: 'noBorders',
        });
      }, 800);
    });
  }
  public async exportTablePDF(){
    var headers = [
      {
        text: '',
        fillColor: '#eeeeee',
        color: '#808080',
        bold: true,
        fontSize: 11,
        alignment: 'left'
      }, 
      ...this.data.flatMap( dat => [
        {
          text: `${dat.name}`,
          fillColor: '#eeeeee',
          color: '#808080',
          bold: true,
          fontSize: 11,
          alignment: 'left'
        },
        {
          text: '%',
          fillColor: '#eeeeee',
          color: '#808080',
          bold: true,
          fontSize: 11,
          alignment: 'left'
        },
      ])
    ];
    var widths = ['*', ...this.data.flatMap( dat => ['*', '*'] )];

    var table = {
      headerRows: 1,
      widths: widths,
      body: [headers]
    }

    this.optionsTable();
    const fontSize = 10;
    for(var i = 0; i<this.labels.length; i++){
      var aux = [];
      aux.push({
        text: `${this.labels[i]}`,
        color: '#808080',
        border: [false, true, false, true],
        fontSize,
      });
      for(const dat of this.dataTable){
        aux.push({
          text: `${dat.valores[i]}`,
          color: '#808080',
          border: [false, true, false, true],
          fontSize,
        }); 
        aux.push({
          text: `${dat.porcentaje[i]}`,
          color: '#808080',
          border: [false, true, false, true],
          fontSize,
        });
      }
      table.body.push(aux);
    }
    

    return {
      table: table,
      width: this.ancho,
      alignment: 'center',
      margin: [0,15,0,15],
      layout: {
        hLineColor: () => '#E0E0E0',
        vLineColor: () => 'white',
      }
    };
  }
  public exportTitles(){
    return {
      text: [
        {text: this.tituloZona, fontSize: 19, bold: true},
        {text: ' • ', fontSize: 19},
        {text: this.subTituloZona, fontSize: 18, color: '#A7A9AC'}
      ],
      margin: [ 0, 10, 0, 10 ]
    }
  }

  public export_suc(){
    this.exportSucursales.emit();
  }

}
